import React, { forwardRef } from 'react'
import { SVGIcon } from 'shared/ui'
import styles from './styles.less'

const BotAvatar = forwardRef((_, ref) => {
  return (
    <div className={styles['bot-avatar-container']} ref={ref}>
      <div className={styles.avatar}>
        <SVGIcon name="robot" size={20} color="color.monochrome.dark" />
      </div>
    </div>
  )
})

export default BotAvatar
